import React from "react";
import { SummaryCard } from "../../../Components/Card";
import { Loader } from "../../../Components/Other";

export default function Overview({ dashboard, loading }) {
  return loading ? (
    <div className="d-flex min-vh-100 align-items-center justify-content-center">
      <Loader width={30} />
    </div>
  ) : (
    <div className="row px-3 row-cols-4 pt-4 row-gap-3">
      <div className="col">
        <SummaryCard
          title="Total Users"
          icon={"carret-right"}
          content={dashboard?.users?.total_users}
        />
      </div>
      <div className="col">
        <SummaryCard title="TOTAL AUM" content={dashboard?.aum?.total_aum} />
      </div>
      <div className="col">
        <SummaryCard
          title="INVESTED USERS"
          content={dashboard?.users?.invested_user}
        />
      </div>
      <div className="col">
        <SummaryCard
          title="NON INVESTED USERS"
          content={dashboard?.users?.non_invested_user}
        />
      </div>
      <div className="col">
        <SummaryCard
          title="AVERAGE AUM"
          content={dashboard?.aum?.average_aum}
        />
      </div>
      <div className="col">
        <SummaryCard title="GOALS CREATED" content={dashboard?.goal_aum || 0} />
      </div>
      <div className="col">
        <SummaryCard
          title="Number of Transactions"
          content={dashboard?.transactions?.total_transactions}
        />
      </div>
      <div className="col">
        <SummaryCard
          title="PENDING TRANSACTIONS"
          content={dashboard?.transactions?.pending_transactions}
        />
      </div>
    </div>
  );
}
